module.exports = __webpack_public_path__ + "static/00015.b33cdf07.jpg";